import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Toasted from 'vue-toasted';

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'CreateTemplateModal',
    components: {
    }
})
export default class CreateTemplateModal extends Vue {
    private name: string = '';

    openModal(): void {
        $(this.$refs.modal!).modal('show');
    }

    closeModal(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private createTemplate(): void {
        this.$emit('created', this.name);
    }
}